export default function HeroSection() {
  const stats = [
    { label: '每日更新', value: '24h', desc: '全天候追踪爆料' },
    { label: '覆盖领域', value: '50+', desc: '网红明星全覆盖' },
    { label: '吃瓜社群', value: '百万', desc: '活跃吃瓜群众' },
  ];

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      {/* Decorative background gradient */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left: Text */}
          <div className="flex-1 w-full text-center lg:text-left">
            {/* Tag */}
            <span className="inline-block text-xs font-semibold bg-primary-100 text-primary-700 px-3 py-1.5 rounded-full mb-5 tracking-wide">
              🔥 黑料最新爆料 · 吃瓜第一线
            </span>

            {/* H1 */}
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              黑料
              <span className="text-primary-600"> · 吃瓜群众的八卦阵地</span>
            </h1>

            {/* Slogan */}
            <p className="mt-3 text-lg text-primary-600 font-medium font-heading">
              黑料吃瓜不打烊，随时随地满足你的八卦好奇心
            </p>

            {/* Intro */}
            <p className="mt-5 text-sm leading-relaxed text-foreground-600 max-w-lg mx-auto lg:mx-0">
              黑料吃瓜网是全网最活跃的八卦爆料聚合平台，专注追踪网红翻车、明星绯闻、热点事件及娱乐圈最新黑料。我们以最快速度汇集黑料吃瓜视频与深度扒皮内容，打造黑料吃瓜在线观看的一站式入口。无论你是资深吃瓜群众还是刚入门的八卦新手，这里都有你想要的吃瓜黑料合集。
            </p>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 max-w-lg mx-auto lg:mx-0">
              平台每日更新海量黑料内容，覆盖娱乐、网红、社会热点等多个领域，黑料爆料团队 24 小时值守，确保每一条猛料第一时间触达你的指尖。
            </p>

            {/* Stats */}
            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-6">
              {stats.map((s) => (
                <div key={s.label} className="text-center">
                  <div className="text-2xl font-bold text-primary-600 font-heading">
                    {s.value}
                  </div>
                  <div className="text-xs text-foreground-500 mt-0.5">{s.label}</div>
                  <div className="text-[10px] text-foreground-400">{s.desc}</div>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line"></i>
                立即吃瓜
              </a>
              <a
                href="#cards"
                className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-semibold text-sm rounded-lg hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer border border-background-300/60"
              >
                <i className="ri-article-line"></i>
                深度扒皮
              </a>
            </div>
          </div>

          {/* Right: Visual */}
          <div className="flex-1 w-full flex items-center justify-center">
            <div className="relative w-full max-w-[480px] aspect-[4/5] rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20editorial%20collage%20style%20composition%20with%20warm%20crimson%20and%20dark%20amber%20tones%2C%20abstract%20news%20and%20gossip%20themed%20visual%2C%20newspaper%20texture%20overlay%2C%20bold%20typography%20elements%2C%20spotlight%20effect%2C%20mysterious%20atmosphere%2C%20entertainment%20industry%20aesthetic%2C%20high%20contrast%2C%20editorial%20photography%20style%20with%20film%20grain%2C%20dramatic%20shadow%20play%2C%20no%20text%20visible%2C%20abstract%20geometric%20shapes%20in%20warm%20red%20and%20gold%20accents&width=960&height=1200&seq=hero-visual-2026-hl&orientation=portrait"
                alt="黑料吃瓜网 · 八卦爆料视觉主题"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background-950/30 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}